import { useLazyQuery } from "@apollo/client";
import { Button, Spinner } from "../../../../components/ui";
import { FETCH_EXHIBITION_WORKS as FETCH_EXHIBITION_WORKS_QUERY } from "../../../../graphql/query/ExhibitionWork";

const CopyDescription = ({ closeModal, exhibitionId }) => {
  const [fetchExhibitionWorks, { loading }] = useLazyQuery(
    FETCH_EXHIBITION_WORKS_QUERY(),
  );

  const handleCopyDescription = async () => {
    const { data } = await fetchExhibitionWorks({
      variables: {
        input: {
          limit: 50,
          offset: 0,
          exhibitionId: exhibitionId,
        },
      },
    });
    const exhibitionWorks = data?.exhibitionWorks || {};
    const descriptions = exhibitionWorks?.edges
      ?.map(work => work?.instance?.description)
      .join("\n");
    await navigator.clipboard.writeText(descriptions);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        disabled={loading}
        label={"Copy description"}
        onClick={handleCopyDescription}
      />
      {loading && <Spinner />}
    </div>
  );
};

export default CopyDescription;
